/**
 * Created by staffanrantzow on 15/03/16.
 */

/* @flow */
import React, {PropTypes } from 'react';
import SideMenuContainer from './side-menu/side-menu-container';
import InfoBoxList from './info-box/info-box-list';

export class LeftSection extends React.Component {

  static propTypes = {
    currentPath: PropTypes.string.isRequired
  };

  render () {
    return (
      <div className='left-section'>
        <SideMenuContainer currentPath={this.props.currentPath} />
        <InfoBoxList />
      </div>
    );
  }
}

export default LeftSection;



/** WEBPACK FOOTER **
 ** ./src/components/left-page-section/left-page-section.js
 **/